import React, { useState } from "react";
import { CheckCircle } from "lucide-react";
import { showToast } from "../../../../../Helper/Toast";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { hitUpdatePasswordClientApi } from "../../../../../Redux/Client/UpdatePasswordClientSlice";
import AccountSecure from "../../../../../assets/img/Account Secure.svg";

const Security = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleUpdatePassword = () => {
    //console.log("Update password clicked");
    if (formData.newPassword !== formData.confirmPassword) {
      showToast("New password and confirm password do not match", "error");
      return;
    }

    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    // 🔹 Validate password strength
    if (!passwordRegex.test(formData.newPassword)) {
      showToast(
        "Password must be at least 8 characters long and include one uppercase letter, one lowercase letter, one number, and one special character.",
        "error"
      );
      return;
    }

    dispatch(
      hitUpdatePasswordClientApi({
        password: formData.newPassword,
        oldPassword: formData.currentPassword,
      })
    )
      .then((response) => {
        if (response.payload && response.payload.status === true) {
          showToast("Password updated successfully", "success");
          // localStorage.removeItem("clientToken");
          // localStorage.removeItem("clientData");
          // localStorage.removeItem("clientId");
          // navigate("/client/login");
        }
      })
      .catch((error) => {
        showToast("Password update failed", "error");
      });
  };

  const handleConnect = (provider) => {
    //console.log(`Connect with ${provider}`);
  };

  return (
    <>
      <div className="password-security-container">
        <h1 className="page-title">Password & Security</h1>

        {/* Change Password Card */}
        <div className="settings-card">
          <h2 className="section-title">Change Password</h2>

          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Current Password</label>
              <input
                type="password"
                name="currentPassword"
                className="form-input"
                value={formData.currentPassword}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label className="form-label">New Password</label>
              <input
                type="password"
                name="newPassword"
                className="form-input"
                value={formData.newPassword}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group full-width">
              <label className="form-label">Confirm New Password</label>
              <input
                type="password"
                name="confirmPassword"
                className="form-input confirm-password-input"
                value={formData.confirmPassword}
                onChange={handleInputChange}
              />
            </div>
          </div>

          {/* OAuth Sections */}
          <div>
            <div className="oauth-section">
              <div className="oauth-info">
                <h3 className="oauth-title">Log in with Google</h3>
                <p className="oauth-description">
                  Not connected. You can choose to log in with Google.
                </p>
              </div>
              <button
                className="connect-button"
                onClick={() => handleConnect("Google")}
              >
                Connect
              </button>
            </div>

            <div className="oauth-section">
              <div className="oauth-info">
                <h3 className="oauth-title">Log in with Apple</h3>
                <p className="oauth-description">
                  Not connected. You can choose to log in with Apple.
                </p>
              </div>
              <button
                className="connect-button"
                onClick={() => handleConnect("Apple")}
              >
                Connect
              </button>
            </div>
          </div>

          <button
            className="update-password-button"
            onClick={handleUpdatePassword}
          >
            Update Password
          </button>
        </div>

        {/* Security Recommendations */}
        <div className="security-section">
          <h3 className="security-header">Security Recommendations</h3>

          <div className="security-status-card">
            <div className="status-header">
              <img src={AccountSecure} className="status-icon" />
              <div className="status-content">
                <h3>Your Account is Secure</h3>
                <p>Your account has been set up the right way</p>
              </div>
            </div>

            <ul className="security-list">
              <li className="security-item">Using a strong password</li>
              <li className="security-item">Never sharing your password</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Security;
